<template>
  <router-view></router-view>
  <!-- <div>{{$store.state.token}}

    <button @click="click">123</button>
  </div> -->


</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
// import axios from 'axios';
import {mapActions} from 'vuex'
// import  graphql from './utils/graphql'
export default {
  name: 'app',
  components: {
    HelloWorld
  },
  methods: {
    isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
   }
  },
  mounted() {
    if (this.isMobile()) {
      document.querySelector('body').setAttribute('style', 'height:1500px')
      document.querySelector('html').setAttribute('style', 'height:1500px')
    } else {
      // alert("pc端");
    }

  }

}
</script>

<style lang="scss">
  
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*{
  margin: 0;
  padding: 0;
}
body,html{
  min-width: 1250px;
  overflow-y: auto;
  height: 100%;
}
.el-cascader__dropdown{
            ul li{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
        }
        }
</style>



// WEBPACK FOOTER //
// src/App.vue